(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/router.js');
'use strict';

const {
  BrowserRouter: Router,
  Route,
  Switch
} = ReactRouterDOM;
const {
  setMetaTags,
  setHeaderImageAltText
} = svs.components.lbUtils.setMetaTags;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const {
  pages: {
    BingoLobby,
    BingoArticles,
    BingoSchool,
    BingoChatSchedule,
    WidgetPage
  },
  components: {
    nav_menu: {
      BingoNavMenu
    }
  }
} = svs.bingo_react;
const {
  MenuTabTypes
} = svs.bingo_react.components.common.constants;
const getPageComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.BingoLobby:
      return BingoLobby;
    case MenuTabTypes.BingoArticles:
      return BingoArticles;
    case MenuTabTypes.BingoSchool:
      return BingoSchool;
    case MenuTabTypes.BingoChatSchedule:
      return BingoChatSchedule;
    default:
      return WidgetPage;
  }
};
const BingoRouter = () => {
  const routes = svs.bingo_react.data.tabsConfig;
  const activeRoutes = routes.filter(route => route.active);
  const lobbyRoute = routes.find(route => route.path === '' && route.tabType === 'lobby');
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, React.createElement(CampaignFlerp, null), React.createElement(BingoNavMenu, {
    routes: activeRoutes
  }), React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: "/",
    render: () => {
      setHeaderImageAltText((lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.logotypeAltText) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label));
      setMetaTags({
        docTitle: (lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.metaTitle) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label),
        metaDesc: (lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.metaDescription) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label)
      });
      return React.createElement(BingoLobby, {
        headerConfig: lobbyRoute.headerConfig,
        widgetAreaIndex: lobbyRoute.widgetArea
      });
    }
  }), activeRoutes.map(route => React.createElement(Route, {
    exact: route.path === '',
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      const Component = getPageComponent(route.tabType);
      setHeaderImageAltText((route === null || route === void 0 ? void 0 : route.logotypeAltText) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label));
      setMetaTags({
        docTitle: (route === null || route === void 0 ? void 0 : route.metaTitle) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label),
        metaDesc: (route === null || route === void 0 ? void 0 : route.metaDescription) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label)
      });
      return React.createElement(Component, {
        headerConfig: route.headerConfig,
        widgetAreaIndex: route.widgetArea
      });
    }
  }))));
};
setGlobal('svs.bingo_react.BingoRouter', BingoRouter);

 })(window);